import React from 'react';
import ImageUpload from '../../components/ImageUpload';
import LoadingModal from '../../components/LoadingModal';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withAlert } from 'react-alert';
import ErrorList from '../../components/ErrorList';
import { getFormSyncErrors, getFormValues, isDirty } from 'redux-form';
import AbstractDocumentCheck from '../../components/AbstractDocumentCheck';
import Helper from '../../helpers';
import { setMediaDevicesEnabled, setModalOpeningCount } from '../../redux/application/actions';
import {
    isMediaDevicesEnabledSelector,
    modalOpeningCountSelector,
    requiresPermissionRequestSelector,
} from '../../redux/application/selector';
import BrowserService from "../../services/helper/browserService";
const isDesktop = !BrowserService.isMobileOrTabled();

class SelfIdentityCheck extends AbstractDocumentCheck {
    constructor(props) {
        super(props);
        this.state = {
            frontPicture: null,
            loading: false,
            passport: false,
            region: null,
            errors: [],
            type: 'id',
            btnLabel: 'Next',
        };
        this.onFrontDrop = this.onFrontDrop.bind(this);
    }

    componentDidMount() {
        const { requiresPermissionRequest } = this.props;
        Helper.getMedias(requiresPermissionRequest);
    }

    backToStatus = () => {
        const { onSetMediaDevicesEnabled } = this.props;
        onSetMediaDevicesEnabled(false);
        if (window.VULOG_CONFIG.FORCE_TO_TAKE_PHOTO) {
            this.props.history.push('/register/status');
        }
    };

    updateComponent = () => {
        const { onSetMediaDevicesEnabled } = this.props;
        onSetMediaDevicesEnabled(true);
        Helper.updateComponent();
    };

    render() {
        return (
            <div className="container-fluid wrapper">
                <div className="d-flex flex-column full-height menu-bar-bottom">
                    <h3 className="page__title">{window.VULOG_TRANSLATE('IDENTITY CHECK')}</h3>

                    <p className="page__description">
                        {window.VULOG_TRANSLATE('Take a picture of your identity card or your passport')}
                    </p>

                    <p className="page__warning">{window.VULOG_TRANSLATE('LANDSCAPE_WARNING_ID')}</p>

                    {window.VULOG_CONFIG.ERROR_DISPLAY_TOP && <ErrorList errors={this.state.errors} canContinue />}

                    <div className="d-flex flex-row mb-3">
                        <div className="flex-grow-1 flex-shrink-0 mr-2 d-flex flex-column image-preview-container-half">
                            <div
                                className="check__container front"
                                style={{ backgroundImage: `url(${window.VULOG_CONFIG.ID_FRONT_PLACEHOLDER_IMAGE})` }}
                            >
                                <ImageUpload
                                    imageExtension={['png', 'jpg', 'PNG', 'JPG']}
                                    ref={ref => (this.imageFrontPicker = ref)}
                                    onChange={this.onFrontDrop.bind(this)}
                                    isMediaDevicesEnabled={this.props.isMediaDevicesEnabled}
                                    modalOpeningCount={this.props.modalOpeningCount}
                                    onSetModalOpeningCount={this.props.onSetModalOpeningCount}
                                    requiresPermissionRequest={this.props.requiresPermissionRequest}
                                />
                            </div>
                            <h6 className="check__title">{window.VULOG_TRANSLATE('Front')}</h6>
                            <button
                                className="btn btn-primary full"
                                onClick={() => this.imageFrontPicker.triggerFileUpload()}
                            >
                                <i className="material-icons va-middle reg">photo_camera</i>
                            </button>
                            {
                                isDesktop && (
                                    <button
                                        className="btn btn-secondary full file-upload-button"
                                        onClick={() => this.imageFrontPicker.openFileInput()}
                                    >
                                        <i className="material-icons va-middle reg">upload</i>
                                    </button>
                                )
                            }
                        </div>
                    </div>

                    {!window.VULOG_CONFIG.ERROR_DISPLAY_TOP && <ErrorList errors={this.state.errors} canContinue />}

                    <div className="d-flex flex-row mt-auto mb-2rem">
                        {this.props.position !== window.VULOG_CONFIG.STEPS[1].screen ? (
                            <button onClick={() => this.cancel()} className="btn btn-primary btn-block">
                                <i className="material-icons va-middle reg">keyboard_arrow_left</i>
                                {window.VULOG_TRANSLATE('Back')}
                            </button>
                        ) : null}

                        {this.state.frontPicture && (
                            <button onClick={() => this.savePhoto()} className="btn btn-primary btn-block">
                                {window.VULOG_TRANSLATE(this.state.btnLabel)}
                                <i className="material-icons va-middle reg">keyboard_arrow_right</i>
                            </button>
                        )}
                    </div>
                    <button id={'backBtn'} style={{ display: 'none' }} onClick={this.backToStatus} />
                    <button id={'stopTrackBtn'} style={{ display: 'none' }} onClick={this.updateComponent} />
                    <LoadingModal loading={this.state.loading} />
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    position: state.register.position,
    formValues: getFormValues('identity-check')(state),
    submitErrors: getFormSyncErrors('identity-check')(state),
    isDirty: isDirty('identity-check')(state),
    isMediaDevicesEnabled: isMediaDevicesEnabledSelector(state),
    modalOpeningCount: modalOpeningCountSelector(state),
    requiresPermissionRequest: requiresPermissionRequestSelector(state),
});

const mapDispatchToProps = dispatch => ({
    onSetMediaDevicesEnabled: bindActionCreators(setMediaDevicesEnabled, dispatch),
    onSetModalOpeningCount: bindActionCreators(setModalOpeningCount, dispatch),
});

export default withAlert(connect(mapStateToProps, mapDispatchToProps)(SelfIdentityCheck));
